/* eslint-disable */
import React, { useState } from 'react';
import './styles/Resources.css';

const Resources = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const resources = [
    {
      id: 1,
      title: 'National Action Plan for Health Security (NAPHS) 2024-2028',
      category: 'policy',
      type: 'PDF',
      size: '2.4 MB',
      date: '2024-10-01',
      description: 'Comprehensive national strategy for health security and emergency preparedness.',
      downloadUrl: '#'
    },
    {
      id: 2,
      title: 'One Health Strategic Plan 2024-2028',
      category: 'policy',
      type: 'PDF',
      size: '1.8 MB',
      date: '2024-09-15',
      description: 'Integrated approach to human, animal, and environmental health.',
      downloadUrl: '#'
    },
    {
      id: 3,
      title: 'Monthly Anthrax Situation Report - October 2024',
      category: 'reports',
      type: 'PDF',
      size: '1.2 MB',
      date: '2024-10-30',
      description: 'Latest surveillance data and outbreak management updates.',
      downloadUrl: '#'
    },
    {
      id: 4,
      title: 'Annual Department Report 2023',
      category: 'reports',
      type: 'PDF',
      size: '3.1 MB',
      date: '2024-03-15',
      description: 'Comprehensive overview of departmental activities and achievements.',
      downloadUrl: '#'
    },
    {
      id: 5,
      title: 'Rapid Response Team Training Manual',
      category: 'guidelines',
      type: 'DOC',
      size: '4.2 MB',
      date: '2024-08-20',
      description: 'Complete training guide for emergency response teams.',
      downloadUrl: '#'
    },
    {
      id: 6,
      title: 'One Health Implementation Framework',
      category: 'guidelines',
      type: 'PDF',
      size: '2.1 MB',
      date: '2024-07-10',
      description: 'Step-by-step guide for implementing One Health approaches.',
      downloadUrl: '#'
    },
    {
      id: 7,
      title: 'Zoonotic Disease Research Paper',
      category: 'research',
      type: 'PDF',
      size: '1.5 MB',
      date: '2024-09-05',
      description: 'Latest research findings on disease transmission patterns.',
      downloadUrl: '#'
    },
    {
      id: 8,
      title: 'Emergency Preparedness Checklist',
      category: 'tools',
      type: 'XLS',
      size: '0.8 MB',
      date: '2024-06-25',
      description: 'Comprehensive checklist for emergency readiness assessment.',
      downloadUrl: '#'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Resources', count: resources.length },
    { id: 'policy', name: 'Policy Documents', count: resources.filter(r => r.category === 'policy').length },
    { id: 'reports', name: 'Reports', count: resources.filter(r => r.category === 'reports').length },
    { id: 'guidelines', name: 'Guidelines', count: resources.filter(r => r.category === 'guidelines').length },
    { id: 'research', name: 'Research', count: resources.filter(r => r.category === 'research').length },
    { id: 'tools', name: 'Tools & Templates', count: resources.filter(r => r.category === 'tools').length }
  ];

  const filteredResources = activeCategory === 'all' 
    ? resources 
    : resources.filter(resource => resource.category === activeCategory);

  const getFileIcon = (type) => {
    switch (type) {
      case 'PDF': return '📄';
      case 'DOC': return '📝';
      case 'XLS': return '📊';
      default: return '📎';
    }
  };

  return (
    <div className="resources-page" id='resources-page'>
      <section className="page-header">
        <div className="container">
          <div className="page-header-content">
            <h1>Resources Library</h1>
            <p className="page-subtitle">
              Access our comprehensive collection of policy documents, reports, guidelines, and research materials
            </p>
          </div>
        </div>
      </section>

      <section className="categories-section">
        <div className="container">
          <div className="categories-grid">
            {categories.map(category => (
              <button
                key={category.id}
                className={`category-card ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                <div className="category-info">
                  <h3>{category.name}</h3>
                  <span className="resource-count">{category.count} resources</span>
                </div>
                <div className="category-arrow">→</div>
              </button>
            ))}
          </div>
        </div>
      </section>

      <section className="resources-grid-section">
        <div className="container">
          <div className="resources-header">
            <h2>
              {activeCategory === 'all' ? 'All Resources' : 
               categories.find(c => c.id === activeCategory)?.name}
            </h2>
            <div className="search-sort">
              <div className="search-box">
                <input type="text" placeholder="Search resources..." />
                <button className="search-btn">🔍</button>
              </div>
              <select className="sort-select">
                <option>Newest First</option>
                <option>Oldest First</option>
                <option>Name A-Z</option>
                <option>Name Z-A</option>
              </select>
            </div>
          </div>

          <div className="resources-grid">
            {filteredResources.map(resource => (
              <div key={resource.id} className="resource-card">
                <div className="resource-header">
                  <div className="file-icon">
                    {getFileIcon(resource.type)}
                  </div>
                  <div className="resource-meta">
                    <span className="file-type">{resource.type}</span>
                    <span className="file-size">{resource.size}</span>
                  </div>
                </div>
                
                <div className="resource-content">
                  <h3 className="resource-title">{resource.title}</h3>
                  <p className="resource-description">{resource.description}</p>
                  
                  <div className="resource-footer">
                    <span className="resource-date">
                      {new Date(resource.date).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      })}
                    </span>
                    <button className="download-btn">
                      Download
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="load-more-section">
            <button className="load-more-btn">
              Load More Resources
            </button>
          </div>
        </div>
      </section>
      <section className="resources-stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">📚</div>
              <div className="stat-number">{resources.length}+</div>
              <div className="stat-label">Total Resources</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">⬇️</div>
              <div className="stat-number">1,247</div>
              <div className="stat-label">Monthly Downloads</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-number">500+</div>
              <div className="stat-label">Active Users</div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🆕</div>
              <div className="stat-number">15+</div>
              <div className="stat-label">New This Month</div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;